import configureApp from 'configureApp';

export const cURL = 'https://login.vedabuilder.com/wp-json/veda/v1/airtable';

export const restore_url = `${configureApp.endpoint.users}/me/report/restore-app`;
